<script>
import { defineAsyncComponent } from "vue";

export default {
  components: {
    CalculatorLamal: defineAsyncComponent(
      () => import("./components/CalculatorLamal.vue"),
    ),
    CalculatorAdditionals: defineAsyncComponent(
      () => import("./components/CalculatorAdditionals.vue"),
    ),
    FreeForm: defineAsyncComponent(() => import("./components/FreeForm.vue")),
  },
  data() {
    return {};
  },
};
</script>
